import React, { memo, useEffect, useState } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { Radio } from '@mantine/core'
import { IconQrcode, IconExternalLink } from '@tabler/icons'
import { Modal, Button, Toast } from '@ow/comps'
import { getQuery, getHostWithProject } from '@vt/utils'
import { getQrCodeUrl } from '@vt/apis/lib-ex/v2/share'

const QRCode = memo(({ url }) => {
  const [qrcodeUrl, setQrcodeUrl] = useState()

  const download = () => {
    const a = document.createElement('a')
    a.href = qrcodeUrl
    a.download = 'qrcode.png'
    a.click()
  }

  useEffect(() => {
    const x = new XMLHttpRequest()
    x.open('GET', getQrCodeUrl(url), true)
    x.responseType = 'blob'
    x.onload = () => {
      setQrcodeUrl(window.URL.createObjectURL(x.response))
    }
    x.send()
  }, [url])

  return (
    <Modal
      title="二维码"
      trigger={
        <Button
          style={{ paddingLeft: '0.3125rem', paddingRight: '0.3125rem' }}
          type="secondary"
          opacityType="sm"
          icon={<IconQrcode />}
        />
      }
    >
      <div className="flex flex-col items-center gap-6">
        <img width={180} height={180} alt={url} src={qrcodeUrl} />
        <Button type="primary" onClick={download}>
          下载
        </Button>
      </div>
    </Modal>
  )
})

const DetailModal = ({ open, detail, onClose }) => {
  if (!detail) return null

  const { tpl } = getQuery()
  const url = `${getHostWithProject()}/share?tpl=${tpl}&sharedId=${
    detail.sharedId
  }`

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeOnDocumentClick={false}
      title="分享"
    >
      <div className="py-4">
        <div>
          <div className="mb-4">请选择可查看人员：</div>
          <Radio label="对外公开（无需登录即可查看）" checked />
        </div>
        <div className="mt-6">
          <div className="mb-4">分享链接：</div>
          <div className="flex gap-2">
            <div
              className="flex items-center gap-2 bg-gray-200 overflow-hidden rounded px-2"
              style={{ maxWidth: 800 }}
            >
              <span className="truncate">{url}</span>
              <CopyToClipboard
                text={url}
                onCopy={() => {
                  Toast.info({ title: '复制成功' })
                }}
              >
                <IconExternalLink className="cursor-pointer shrink-0 hover:opacity-60" />
              </CopyToClipboard>
            </div>
            <CopyToClipboard
              text={url}
              onCopy={() => {
                Toast.info({ title: '复制成功' })
              }}
            >
              <Button type="primary">复制</Button>
            </CopyToClipboard>

            <QRCode url={url} />
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default memo(DetailModal)
